import React from "react";
import Box from "@material-ui/core/Box";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import { makeStyles } from "@material-ui/styles";
import { useSelector } from "react-redux";
import clsx from "clsx";

import {
  ActionSnackbar,
  ActionsSnackbar,
} from "../../components/Snackbar/Snackbars";
import { getNotifications } from "../../store/selectors/notifications";
import { isDrawerModalOpen } from "../../store/selectors/modal";
import { isRouteSchedulingOpen } from "../../store/selectors/schedule";

export const NotificationType = {
  ACTION: "ACTION",
  ACTIONS: "ACTIONS",
  WARNING: "WARNING",
};

const useStyles = makeStyles(() => ({
  container: {
    position: "fixed",
    top: "2.813rem",
    right: "1.25rem",
    zIndex: 1301, // make the container overlap MUI Dialog
  },
  modalContainer: {
    top: "6.875rem",
  },
  wrapper: {
    marginBottom: "0.625rem",
    justifyContent: "flex-end",
    display: "flex",
  },
  component: {
    position: "relative",
    minWidth: 0,
    width: "fit-content",
  },
}));

const getSnackbar = (type) => {
  switch (type) {
    case NotificationType.ACTION:
      return ActionSnackbar;
    case NotificationType.ACTIONS:
      return ActionsSnackbar;
    default:
      return SnackbarContent;
  }
};

const Notifier = () => {
  const classes = useStyles();

  const notifications = useSelector(getNotifications);
  const drawerModalOpen = useSelector(isDrawerModalOpen);
  const isRouteSchedule = useSelector(isRouteSchedulingOpen);

  return (
    <Box
      className={clsx(classes.container, {
        [classes.modalContainer]: drawerModalOpen || isRouteSchedule,
      })}
    >
      {notifications.map(({ key, ...notification }) => {
        const Component = getSnackbar(notification.type);

        return (
          <Box key={key} className={classes.wrapper}>
            <Component
              className={classes.component}
              open={true}
              {...notification}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default Notifier;
